import React from 'react';

import type { Nullable } from '@clearverify/types';

import { VerificationRequestStatus } from 'src/api';
import { StepItem, Stepper } from 'src/components/common';

import { STEP_LABELS } from './constants';

interface VerificationRequestStatusBarProps {
  status: Nullable<string>;
  isMyVerifyRequest: Nullable<boolean>;
}

export const VerificationRequestStatusBar: React.FC<VerificationRequestStatusBarProps> = ({
  status,
  isMyVerifyRequest = false,
}) => {
  const steps = React.useMemo((): StepItem[] => {
    const isDeclinedByVerifier = status === VerificationRequestStatus.DeclinedByVerifier;
    const isDeclinedByEmployee = status === VerificationRequestStatus.DeclinedByEmployee;

    const reviewedByVerifierStep: StepItem = {
      key: VerificationRequestStatus.ReviewedByVerifier,
      label: STEP_LABELS[VerificationRequestStatus.ReviewedByVerifier],
    };

    if (isMyVerifyRequest) {
      if (isDeclinedByVerifier) {
        return [
          {
            key: VerificationRequestStatus.VerifierToRespond,
            label: STEP_LABELS[VerificationRequestStatus.VerifierToRespond],
          },
          {
            key: VerificationRequestStatus.DeclinedByVerifier,
            label: STEP_LABELS[VerificationRequestStatus.DeclinedByVerifier],
            error: true,
          },
          reviewedByVerifierStep,
        ];
      }

      return [
        {
          key: VerificationRequestStatus.VerifierToRespond,
          label: STEP_LABELS[VerificationRequestStatus.VerifierToRespond],
        },
        {
          key: VerificationRequestStatus.ReportCreated,
          label: STEP_LABELS[VerificationRequestStatus.ReportCreated],
        },
        reviewedByVerifierStep,
      ];
    }

    if (isDeclinedByEmployee) {
      return [
        {
          key: VerificationRequestStatus.EmployeeToRespond,
          label: STEP_LABELS[VerificationRequestStatus.EmployeeToRespond],
        },
        {
          key: VerificationRequestStatus.DeclinedByEmployee,
          label: STEP_LABELS[VerificationRequestStatus.DeclinedByEmployee],
          error: true,
        },
        reviewedByVerifierStep,
      ];
    }

    return [
      {
        key: VerificationRequestStatus.EmployeeToRespond,
        label: STEP_LABELS[VerificationRequestStatus.EmployeeToRespond],
      },
      {
        key: VerificationRequestStatus.ReportCreated,
        label: STEP_LABELS[VerificationRequestStatus.ReportCreated],
      },
      reviewedByVerifierStep,
    ];
  }, [isMyVerifyRequest, status]);

  return <Stepper steps={steps} activeStepKey={status} />;
};
